module.exports = __webpack_public_path__ + "static/media/img-104.3856a688.jpg";